module.exports = __webpack_public_path__ + "img/QR-img3.3e331bf3.png";